import React from "react";
import { Card } from "react-bootstrap";

import MessageItem from "./MessageItem";
import ChatInput from "./ChatInput";
import ChatHeader from "./ChatHeader";

const ChatContainer = ({
  getMessages,
  sendMessage,
  refetchChatRoom,
  refetch,
}) => {
  return (
    <Card>
      <ChatHeader refetchChatRoom={refetchChatRoom} />
      <div className="chat_container">
        {getMessages?.map((message) => {
          return (
            <React.Fragment key={message.id}>
              <MessageItem message={message} refetch={refetch} />
            </React.Fragment>
          );
        })}
      </div>
      <ChatInput sendMessage={sendMessage} />
    </Card>
  );
};

export default ChatContainer;
